import dayjs from 'dayjs';
import React, { useState } from 'react';
import DownloadCSV from '~components/molecules/DownloadCSV';
import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum } from '~utils/enums';

const BranchInventoryExportCSV = () => {
    const branchInventoryListing = useAppSelector(
        (state) => state.gold.goldInventoryReport.branchInventory.data
    );

    const [isReadyToExport, setIsReadyToExport] = useState(false);

    const handleClick = () => setIsReadyToExport(true);
    const handleCleanup = () => setIsReadyToExport(false);

    const listHeader = [
        'PRODUCT NAME',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL GOLD WEIGHT (g)',
        'FUND TYPE',
    ];

    const listData = isReadyToExport
        ? branchInventoryListing.map(item => [
            item.productName,
            item.serialNo ? item.serialNo.join(', ') : '-',
            item.amount || '-',
            item.physicalGoldWeight ? item.physicalGoldWeight : item.paperGoldWeight,
            FundTypeEnum[item.fundType],
        ])
        : [];

    return (
        <DownloadCSV
            buttonLabel='Export to CSV'
            header={listHeader}
            data={listData}
            fileName={dayjs().format('DD-MM-YYYY').concat(' Branch Inventory')}
            onClick={handleClick}
            cleanup={handleCleanup}
            isLoading={false}
        />
    );
};

export default BranchInventoryExportCSV;
